import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Message, MessageConfig } from './message.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';
import { AtomService } from '../atom.service';

@Resource({
  type: 'tags',
})
export class Tag extends AtomResource {
  @Attribute() name?: string;
  @Attribute() desc?: string;

  @Relationship() messages?: Message[];
}
export class TagConfig implements ResourceConfig {
  tables = {
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
          },
        ],
        header: 'Name',
        displayed: true,
        sort: 'name',
      },
      {
        columnDef: 'description',
        displayedDatas: [
          {
            path: ['desc'],
            class: 'mat-body-2',
          },
        ],
        header: 'Description',
        displayed: true,
      },
      {
        columnDef: 'messages',
        header: 'Messages',
        displayed: true,
        link: {
          resource: 'messages',
          list: 'messages',
          target: 'tags',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'shopping_basket',
      title: [
        {
          path: ['name'],
        },
      ],
      id: true,
    },
    elements: [
      {
        resource: {
          APIKey: 'messages',
          config: new MessageConfig(this.atom),
          multiple: true,
        },
      },
      {
        list: [
          {
            icon: 'description',
            title: 'Description',
            APIKey: 'desc',
            value: {
              path: ['desc'],
            },
          },
        ]
      },
    ],
  }
  wizard = {
    tabs: [
      {
        title: 'Tag',
        formGroup: 'tag',
        list: [
          {
            type: 'text',
            title: 'Name',
            APIKey: 'name',
            formControl: 'name',
            required: true,
            noCols: true,
          },
          {
            type: 'text',
            title: 'Description',
            APIKey: 'desc',
            formControl: 'desc',
            required: false,
            noCols: true,
          },
        ],
      },
    ],
  };
  resource = Tag;
  resourceKey?: string | undefined = 'tags';
  resourceKeySingle?: string | undefined = 'tag';
  resourceName = 'tags';
  includes = ['messages'];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('name', 'Name', true),
  ];
  constructor (private atom: AtomService) {}
}
